"use strict";

var Backbone                            = require("backbone");
var _                                   = require("underscore");
var $                                   = require("jquery");
Backbone.$ = $;

var debug                               = require("debug")("views:OverlayEntitiesView");    //https://github.com/visionmedia/debug


/**
 * OverlayEntitiesView : overlay view displaying semantic datas (entities)
 */
module.exports=Backbone.View.extend({

    model:null,         // RetronewsPageSemanticModel
    className:"overlay overlay-entities",

    initialize:function(options){
        var T=this;
        _.extend(T, options);
        if(T.hide){
            T.$el.addClass("hide");
        }
        T.listenTo(T.model,"sync",T.render);
        T.render();
    },

    render:function(){
        var T=this;

        T.$el.html("");
        if(T.model.fetched){
            debug("render, page "+T.page);
            var entities=T.model.get("entities"),
                width=T.model.get("width"),
                height=T.model.get("height");

            if(entities.blocks){
                _.mapObject(entities.blocks, function(block/*, key*/) {
                    _.each(block,function(entity){
                        if(entity.type=="Geo"||entity.type=="Person"||entity.type=="Organisation"){
                            _.each(entity.boxes,function(box){
                                 var $div=$("<div/>",{
                                    class:"entity entity-"+entity.type
                                });
                                $div.css({
                                    top:(box.top*100/height)+"%",
                                    left:(box.left*100/width)+"%",
                                    height:(box.height*100/height)+"%",
                                    width:(box.width*100/width)+"%"
                                });
                                T.$el.append($div);

                            });
                        }
                    });
                });
            }
        }
    },

    close:function(){
        var T=this;
        T.stopListening();
        T.undelegateEvents();
    }
});